export default {
    PROVIDERS: {
        GOOGLE: 'google',
    },
    CONFIG: {
        GOOGLE: {
            apiKey: 'AIzaSyB8qiAk1mAGGFnz68B9m1IMZgDfdWMoNFk',
            chartsScriptUrl: 'https://www.gstatic.com/charts/loader.js',
        },
    },
};
